import type { ClientConfig } from '../types';
import { incubetaBrand } from './brand';

const CDN = 'https://cdn.alison.ai/whitelabel/incubeta';

export const incubeta: ClientConfig = {
  name: 'Incubeta',
  hosts: [
    // Incubeta-owned names are placeholders until Incubeta confirms them.
    'chain.cpi.incubeta.com',
    'chain.incubeta.alison.ai',
    'chain.cpistg.incubeta.com',
    'incubeta-chain.stg.alison.ai',
    // 'localhost:5173', // uncomment to preview locally (or set VITE_WHITELABEL_HOST)
  ],
  logo: `${CDN}/CPI_RGB.png`,
  icon: `${CDN}/incubeta-favicon-150x150.png`,
  stylesheet: '/whitelabel/incubeta/incubeta.css',
  brand: incubetaBrand,
  providerName: 'Incubeta',
  picksLabel: 'Outperform',
  websiteUrl: 'https://incubeta.com/',
  hiddenNav: [],
  knowledgeDocs: [
    {
      title: 'Creative Element Taxonomy',
      subtitle: 'Every creative attribute we tag, grouped by category',
      icon: 'taxonomy',
      href: '/whitelabel/incubeta/creative-element-taxonomy.html',
    },
    {
      title: 'System KPI Catalog',
      subtitle: 'Every metric we calculate, with its exact formula',
      icon: 'kpi',
      href: '/whitelabel/incubeta/system-kpi-catalog.html',
    },
  ],
  email: {
    supportEmail: 'support@cpi.incubeta.com',
    fromEmail: 'noreply@cpi.incubeta.com',
    fromName: 'Incubeta',
    sendgridClient: 'incubeta',
  },
};
